/* VUE
-------------------------------------------------------------- */
import Vue from 'vue';

/* VUEX
-------------------------------------------------------------- */
import Vuex from 'vuex';

Vue.use(Vuex);

/* VUE-AXIOS
-------------------------------------------------------------- */
import axios from 'axios';
import VueAxios from 'vue-axios';
import {ADD_META, RESET_META, SET_LAST_LOADED_TABLE} from '@/store/main/types';
Vue.use(Vuex, VueAxios, axios);

export const setLoadOverlay = (context: any, loadOverlay: boolean) => {
    context.commit('SET_LOAD_OVERLAY', loadOverlay);
};

export const setAlertNotification = (context: any, data: any) => {
    context.commit('SET_ALERT_NOTIFICATION', data);
};

export const setPersonTypes = (context: any, personTypes: any) => {
    context.commit('SET_PERSON_TYPES', personTypes);
};

export const resetMeta = (context: any) => {
    context.commit(RESET_META);
};

export const addMeta = (context: any, mutation: {name: string, meta: any}) => {
    context.commit(ADD_META, mutation);
};

export const setLastLoadedTable = (context: any, tableName: string) => {
    context.commit(SET_LAST_LOADED_TABLE, tableName);
};
